'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecommendedVenues = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _VenueBlock = require('./VenueBlock');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecommendedVenues = exports.RecommendedVenues = function RecommendedVenues(_ref) {
  var recommendations = _ref.recommendations,
      venue = _ref.venue;
  return recommendations.length ? _react2.default.createElement(
    'div',
    { className: 'recommended-venues' },
    _react2.default.createElement(
      'span',
      { className: 'recommended-venues__text' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'recommended.venues',
        defaultMessage: 'If you like {venue}, you may also enjoy',
        values: { venue: venue }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'recommended-venues__items' },
      recommendations.map(function (recommendation) {
        return _react2.default.createElement(_VenueBlock.VenueBlock, {
          key: recommendation.venue,
          url: '/studios/' + recommendation.alias,
          imageUrl: recommendation.imageUrl,
          venue: recommendation.venue
        });
      })
    )
  ) : null;
};

RecommendedVenues.propTypes = {
  recommendations: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    alias: _propTypes2.default.string,
    imageUrl: _propTypes2.default.string,
    venue: _propTypes2.default.string
  })),
  venue: _propTypes2.default.string
};